import actions from '../actions/FavoritesActions';

const {
    RESET_EMAIL_STATE,
    SET_PERSONALIZED_MESSAGE,
    SET_RECIPIENT_EMAILS,
    SET_SENDER_EMAIL,
    SET_SENDER_NAME,
    SET_SHOW_NOTES,
} = actions;

const emailState = (state = {}, payload) => {
    switch (payload.type) {
        case RESET_EMAIL_STATE:
            return {
                personalizedMessage: '',
                recipientEmails: [],
                senderName: '',
            };
        case SET_PERSONALIZED_MESSAGE:
            return { ...state, personalizedMessage: payload.personalizedMessage };
        case SET_RECIPIENT_EMAILS:
            return { ...state, recipientEmails: payload.recipientEmails };
        case SET_SENDER_EMAIL:
            return { ...state, senderEmail: payload.senderEmail };
        case SET_SENDER_NAME:
            return { ...state, senderName: payload.senderName };
        case SET_SHOW_NOTES:
            return { ...state, showNotes: payload.showNotes };
        default:
            return state;
    }
};

export default emailState;
